var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 80",
    style: {
      enableBackground: "new 0 0 85 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,36.8h-4.5c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,1-0.6,1.5l0,16.3c0,1.2,0.9,2.1,2.1,2.1 c1.2,0,2.2-0.9,2.2-2.1v-4.9h2.3c3.8,0,6.8-3,6.8-6.7C23.7,39.8,20.7,36.8,16.9,36.8z M16.9,46h-2.3v-4.9H17c1.4,0,2.5,1.1,2.5,2.5 C19.5,44.8,18.3,46,16.9,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.1,36.8h-4.5c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,1-0.6,1.5c0,0,0,15.7,0,15.8c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6c0.1,0,3.3,0,4.6,0c4.8-0.1,8.3-4.3,8.3-10C43.6,40.8,40.2,36.8,35.1,36.8z M35.2,52.5c-0.5,0-1.5,0-2.4,0 c0-1.9,0-9.6,0-11.5h2.3c3.9,0,4.2,4.4,4.2,5.7C39.3,49.6,38.1,52.5,35.2,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49,38.8v16.1c0,1.2,1,2.1,2.1,2.1c1.2,0,2.1-1,2.1-2.1v-6.1h3.9c1.2,0,2.1-1,2.1-2.1c0-1.2-1-2.1-2.1-2.1 h-3.9v-3.6h4.4v0c1.2,0,2.1-1,2.1-2.1c0-1.2-1-2.1-2.1-2.1h-6.5C50,36.6,49,37.6,49,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67,0c-7.2,0-13.5,4.3-16.3,10.4l-0.1-0.1c-2-2.1-4.8-3.3-7.8-3.3H14.4C10.8,7,8,9.9,8,13.4v14.3H6.4 c-3.5,0-6.4,2.9-6.4,6.4v25.7c0,3.5,2.9,6.4,6.4,6.4H8v7.4c0,3.5,2.9,6.4,6.4,6.4H56c3.5,0,6.4-2.9,6.4-6.4v-7.4H64 c3.5,0,6.4-2.9,6.4-6.4V35.7C78.7,34.1,85,26.8,85,18C85,8.1,76.9,0,67,0z M70.3,32.7c-1,0.2-2.1,0.3-3.3,0.3c-0.4,0-0.8,0-1.2,0 c-1.5-0.1-3-0.5-4.3-1c-2.3-0.9-4.3-2.4-5.9-4.3C53.3,25,52,21.7,52,18v0c0-1.8,0.3-3.6,0.9-5.2C55.1,7.1,60.6,3,67,3 c8.3,0,15,6.7,15,15C82,25.2,77,31.2,70.3,32.7z M12.3,13.4c0-1.2,1-2.1,2.1-2.1h28.5c1.7,0,3.4,0.7,4.7,2l1.7,1.8 C49.1,16,49,17,49,18c0,3.5,1,6.9,2.8,9.7H12.3V13.4z M58.2,73.6c0,1.2-0.9,2.1-2.1,2.1H14.4c-1.2,0-2.2-0.9-2.2-2.1v-7.4h45.9 V73.6z M66.1,59.7c0,1.2-1,2.2-2.2,2.2H6.4c-1.2,0-2.1-1-2.1-2.2V34.1c0-1.2,1-2.1,2.1-2.1h49.2c2.9,2.4,6.5,3.8,10.5,4V59.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.2,9.6 64.6,20.2 60.4,16 58.1,18.3 57.6,18.8 61.5,22.7 64.6,25.8 78,12.4  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfOk);
export default __webpack_public_path__ + "static/media/pdfOK.dfa536c4.svg";
export { ForwardRef as ReactComponent };